import { Button } from "$components/button/button";
import { PlusIconBorderless, SmartRecommendationIcon } from "$components/icons";
import { Box, styled, Typography } from "@material-ui/core";
import React from "react";

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const ChipContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

const InfoContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

const StyledStarIcon = styled(SmartRecommendationIcon)(() => ({
  fontSize: "2rem",
}));

const InfoText = styled(Typography)(({ theme }) => ({
  fontSize: "1.125rem",
  color: theme.palette.text.secondary,
}));

interface GuidedDiagnosisChipProps {
  onDiagnosisSelected: () => void;
}
export const GuidedDiagnosisChip: React.FC<GuidedDiagnosisChipProps> = ({
  onDiagnosisSelected,
}) => {
  const handleChipClick = () => {
    onDiagnosisSelected();
  };

  return (
    <Container>
      <ChipContainer>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<PlusIconBorderless />}
          onClick={handleChipClick}
          data-testid="guided-diagnosis-malaria-chip"
        >
          {"Malaria (Confirmed)"}
        </Button>
      </ChipContainer>

      <InfoContainer>
        <StyledStarIcon />
        <InfoText>This patient had a positive Malaria test recently</InfoText>
      </InfoContainer>
    </Container>
  );
};
